module.exports = __webpack_public_path__ + "static/media/bg-banner-contact.c3af67e3.jpg";